<template>
	<div id="document-category-picker">
		<v-select :options="compCategoryOptions" required placeholder="Category *" v-model="category"></v-select>
		<v-select :options="compSubCategoryOptions" placeholder="Sub Category" v-model="sub_category"></v-select>

		<div v-if="!prop_crud" class="hide">
			<input type="hidden" name="category_id" :value="category ? category.id : null">
			<input type="hidden" name="sub_category_id" :value="sub_category ? sub_category.id : null">
		</div>
		<div v-else>
			<input type="text" name="category_id" id="category_id" class="category_id" required :value="sub_category ? sub_category.id : category ? category.id : null">
			<span class="form-error" data-form-error-for="category_id">A category is required.</span>
		</div>
	</div>
</template>

<script>
	import vSelect from "vue-select";

	export default {
		components: { vSelect },
		name: 'document-category-picker',
		props: {
			prop_crud: { default: false },
			prop_categories: { type: String, required: true },
			prop_category_id: { default: false },
			prop_sub_category_id: { default: false },
		},
		computed: {
			compCategoryOptions() {
				return this.categories;
			},
			compSubCategoryOptions() {
				if(!this.category) {
					this.sub_category = null;
					return [];
				}

				return this.category.children;
			}
		},
		data() {
			return {
				categories: [],
				category: null,
				sub_category: null
			}
		},
		mounted() {
			this.categories = JSON.parse(this.prop_categories);
			console.log(this.prop_category_id);
			for(let category of this.categories) {
				if (category.id == this.prop_category_id) {
					this.category = category;

					for(let sub_category of category.children) {
						if (sub_category.id == this.prop_sub_category_id) {
							this.sub_category = sub_category;

							break;
						}
					}

					break;
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	#document-category-picker {
		.dropdown {
			margin-bottom: 15px;
		}

		.category_id {
			display: none;
		}
	}
</style>


// WEBPACK FOOTER //
// assets/js/vue/components/DocumentCategoryPicker.vue